'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocationModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Modal = require('../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'modalWrapper': 'ccl-c158947011680351',
  'modalHeader': 'ccl-b5a044c3742b89f4',
  'modalContent': 'ccl-69a283f3476817ac',
  'hasOverflow': 'ccl-c5cb3217d7ae27ed'
};

/**
 * A Modal dialog for displaying LocationSearch
 */

function LocationModal(_ref) {
  var appElement = _ref.appElement,
      isOpen = _ref.isOpen,
      hasOverflow = _ref.hasOverflow,
      headerTitle = _ref.headerTitle,
      renderFooter = _ref.renderFooter,
      onClose = _ref.onClose,
      closeButtonLabel = _ref.closeButtonLabel,
      children = _ref.children;

  return _react2.default.createElement(
    _Modal2.default,
    {
      id: 'location-modal',
      appElement: appElement,
      type: 'fullscreen',
      isContentEdgeToEdge: true,
      hasOverflow: hasOverflow,
      isOpen: isOpen,
      onClose: onClose,
      closeButtonLabel: closeButtonLabel,
      headerTitle: headerTitle,
      renderFooter: renderFooter
    },
    function (header) {
      return _react2.default.createElement(
        'div',
        { className: styles.modalWrapper },
        _react2.default.createElement(
          'div',
          { className: styles.modalHeader },
          header
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames3.default)(styles.modalContent, _defineProperty({}, styles.hasOverflow, hasOverflow)) },
          children
        )
      );
    }
  );
}

LocationModal.displayName = 'LocationModal';
LocationModal.propTypes = {
  /**
   * Allows you to specify the portion of your app that should be hidden
   * (via aria-hidden) to prevent assistive technologies such as screenreaders
   * from reading content outside of the content of your modal.
   */
  appElement: _propTypes2.default.string.isRequired,

  /**
   * Whether the modal is open or no.
   */
  isOpen: _propTypes2.default.bool.isRequired,

  /**
   * Whether the contents of the dialog can overflow the modal’s bounding box
   */
  hasOverflow: _propTypes2.default.bool,

  /**
   * Header title text
   */
  headerTitle: _propTypes2.default.string.isRequired,

  /**
   * Render function for the footer area of the Modal
   */
  renderFooter: _propTypes2.default.func.isRequired,

  /**
   * Event handler for when the close button is clicked.
   */
  onClose: _propTypes2.default.func.isRequired,

  /**
   * Accessibility label for the close button.
   */
  closeButtonLabel: _propTypes2.default.string.isRequired,

  /**
   * The contents of the Location Modal.
   */
  children: _propTypes2.default.node.isRequired
};

LocationModal.defaultProps = {
  hasOverflow: false
};